(($) => {
  $(document).ready(() => {
    const form = $('#searchform')
    const input = form.find('input[name=s]')
    const button = $('#searchsubmit')
    const close = $('#closesearch')

    close.click(() => form.removeClass('open'))

    button.click((e) => {
      e.preventDefault();
      if (form.hasClass('open'))
        return form.submit()

      form.addClass('open')
      input.focus()
    })
  });
})(jQuery)

